import { connect } from 'react-redux';

import VariableStuff from "../../components/variableStuff";
import * as currentPerformanceActions from "../../actions/currentPerformance";
import * as actionsGroup from "../../actions/group";
import * as actionsFaculty from "../../actions/faculty";
import * as actionsManagement from "../../actions/management"
// import * as actionsStudyYear from "../../actions/schedule"


const mapStateToProps = (state) => ({
    data: state.currentPerformance.students,
    token: state.auth.token,
    pagesNum: state.currentPerformance.studentPagesCount,
    totalCount: state.currentPerformance.studentsTotalCount,
    educationYear: state.group.educationYearVariableStaff,
    groups: state.group.groupListVariableStaff,
    loading: state.currentPerformance.isLoading,
    faculty: state.faculty.list,
    studyYear: state.group.years,
    cathedras: state.management.cathedra,
});

const mapDispatchToProps = (dispatch) => ({
    fetchStudents: (pageNumber, findStudent, faculty, kurs, group, selectedStatus, year, cathedra) => dispatch(currentPerformanceActions.students(pageNumber, findStudent, faculty, kurs, group, selectedStatus, year, cathedra)),
    fetchEducationYear: (params) => dispatch(actionsGroup.getEducationYearVariableStuff(params)),
    fetchGroup: (params) => dispatch(actionsGroup.getGroupListVariableStuff(params)),
    // fetchGroup: () => dispatch(actionsGroup.getGroupList()),
    fetchFaculty: () => dispatch(actionsFaculty.list()),
    fetchStudyYear: () => dispatch(actionsGroup.schoolYear()),
    fetchCathedras: (facultyId, val, isJournalAdmin) => dispatch(actionsManagement.getCathedra(facultyId, val, isJournalAdmin)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VariableStuff);
